import React, { createContext, useContext, useState } from 'react';

const ErrorContext = createContext(null);

export const ErrorProvider = ({ children }) => {
    const [errorModal, setErrorModal] = useState({ show: false, error: null, title: 'Ошибка' });

    const showError = (error, title = 'Ошибка') => {
        setErrorModal({ show: true, error, title });
    };

    const hideError = () => {
        setErrorModal({ show: false, error: null, title: 'Ошибка' });
    };

    return (
        <ErrorContext.Provider value={{ showError, hideError, errorModal }}>
            {children}
        </ErrorContext.Provider>
    );
};

export const useError = () => {
    const context = useContext(ErrorContext);
    if (!context) {
        throw new Error('useError must be used within ErrorProvider');
    }
    return context;
};

